/**
 * @Author: Jon Lucas
 * @Date:   2017-09-11T14:41:41+02:00
 * @Email:  jon.lucas@mazedia.fr
 * @Last modified by:   Jon Lucas
 * @Last modified time: 2017-09-11T16:03:18+02:00
 */

import { Component, ElementRef, OnInit } from "@angular/core";
import { LoaderUtils } from "./util/LoaderUtils";
import { AppLoadingStateService } from "./app-loading-state.service";
import { ApiUtils } from "./util/ApiUtils";
import { GoogleAnalytics } from "./google-analytics";
import { Router, ActivatedRoute, ActivationEnd } from "@angular/router";
import { environment } from "../environments/environment";
import { AuthUtils } from "./util/AuthUtils";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {
    public readonly TAG: string = "[AppComponent]";

    public title: string = "Configurateur Nicoll";

    public isAuthenticate: boolean = false;
    public needAuthentication: boolean = true;
    public isFullscreen: Boolean = false;

    constructor(
        private router: Router,
        private el: ElementRef,
        private appLoadingStateService: AppLoadingStateService,
        private apiUtils: ApiUtils,
        private authUtils: AuthUtils
    ) { }

    public ngOnInit(): void {
        // Start Google Analytics
        new GoogleAnalytics(this.router);

        this.apiUtils.loadDevisById();

        if (environment.has_contact_form) {
            this.apiUtils.completeContactForm();
        }

        this.router.events.subscribe((route) => {
            if (route instanceof ActivationEnd && route.snapshot.routeConfig.path === "authentication/:token" && environment.need_authentication) {
                if (localStorage.getItem('authorized') !== null && route.snapshot.params.token === localStorage.getItem('authorized')) {
                    this.isAuthenticate = true;
                } else {
                    this.isAuthenticate = false;
                }
            } else if (route instanceof ActivationEnd && environment.need_authentication && localStorage.getItem('authorized')) {
                this.isAuthenticate = true;
            } else if (route instanceof ActivationEnd) {
                this.isAuthenticate = this.authUtils.isAuthenticate();
            }

            if (route instanceof ActivationEnd && route.snapshot.routeConfig.path === "view/fullscreen") {
                this.isFullscreen = true;
            } else if (route instanceof ActivationEnd) {
                this.isFullscreen = false;
            }
        });

        this.appLoadingStateService.subject.subscribe(
            appLoaded => {
                if (appLoaded) {
                    setTimeout(() => LoaderUtils.hideLoader("app-loader", true), 1000);
                }
            }
        );

        LoaderUtils.addLoader("app-loader", <HTMLElement>this.el.nativeElement, true);
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts